import React from 'react'
import flask from '../images/flask.jpg'
import flask1 from '../images/flask1.jpg'
import flask2 from '../images/flask2.jpg'
import flask3 from '../images/flask3.jpg'
import GooeyButton from './GooeyButton'
import { ethers } from 'ethers'
import { serumAbi,serumAddress } from '../contracts/serums'

import "./Burn.scss"
import Modal from './Modal'


const Burn = () => {
    const[openModal,setModalOpen] = React.useState(false);
    const[currSerumId,setCurrSerumId] = React.useState(0);
    const[currMaxForModal,setCurrMaxForModal] = React.useState(0);
    function getIdFromName(name){
        if(name == 'Flask of Sleepiness'){
            return 1
        }
        if(name == "Vial of Sleep"){
            return 2;
        }
        if(name == "Ether Elixir"){
            return 3;
        }
        if(name == "777 Vessel"){
            return 4;
        }
    }
    const amountOwned = [
    
        {
            name: "Flask of Sleepiness",
            amount_claimable: 0,
            src: flask
        },
        {
            name: "Vial of Sleep",
            amount_claimable: 0,
            src: flask1
        },
        {
            name: "Ether Elixir",
            amount_claimable: 0,
            src:flask2
        },
        {
            name: "777 Vessel",
            amount_claimable: 0,
            src: flask3
        }
    ] 

    const[amountOwnedInfo,setAmountOwnedInfo] = React.useState(amountOwned);

    const getAmountOwnedInfo = async () => {
        if(window.ethereum){
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider.getSigner();
            const address = await signer.getAddress();
            const serums = new ethers.Contract(serumAddress,serumAbi,signer);
            const _amountOwned = await serums.balanceOfBatch([address,address,address,address],[0,1,2,3]);
            setAmountOwnedInfo(amountOwnedInfo => {
                let temp = amountOwnedInfo;
                console.log(temp);
                // return temp;
                
                for(let i =0; i<amountOwned.length; i++){
                    temp[i].amount_claimable = _amountOwned[i].toNumber();
                
                }
                // let data = JSON.parse(temp);
                // let dattemp
                return [...new Set(temp)]

            })
    
        
        }

    }

    React.useEffect(()=>{
        console.log("bunda")
        // flushSync(getAmountOwnedInfo)
        getAmountOwnedInfo();
    },[])

    // const burnSerum = async (serumId){

    // }


  return (
      <>

    <div class=' w-screen mb-6 text-justify'>
    <div class='mt-12 flex flex-col m-auto  max-w-2xl'>
        <h1 class='text-center font-bold text-3xl'>Burn Your Vial For A Sleepy Mutant</h1>
  
    </div>
    </div>
    

    <div class=' grid grid-cols-1 gap-y-8 sm:grid-cols-2 lg:grid-cols-4  place-items-center'>
        


        {amountOwnedInfo.map((data)=>{return(
             <div class=''>
            <img  class={`h-64 expand ${data.amount_claimable>0? "animate-pulse":""} m${getIdFromName(data.name)}`} src={data.src}></img>
             <br></br>
             <div 
            onClick={()=>{
                setCurrSerumId(getIdFromName(data.name) - 1 )
                setCurrMaxForModal(data.amount_claimable)
                setModalOpen(true)}}
             class='text-center'
             >
              
                 <h1 class='mb-2 font-semibold z-10'>{data.name}</h1>
                 <GooeyButton text={`Burn`}/>               
                 </div>
                 <p className='text-center'>Amount Owned: {data.amount_claimable}</p>
         </div>
        )})}

        <Modal open={openModal} setOpen={setModalOpen} maxAmount={currMaxForModal} serumId={currSerumId} />
  

    </div>
    </>
  )
}

export default Burn